import { Mediaclip } from './../../../interfaces/mediaclip';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { MediatypeIconPipe } from './../../../pipes/mediatypeIcon.pipe';
import { StatusIconPipe } from './../../../pipes/statusIcon.pipe';
import { ClipTitlePipe } from './../../../pipes/clipTitle.pipe';
import { SapiService } from './../../../services/sapi.service';
import { Component, ElementRef, OnDestroy } from '@angular/core';
import { WorklistService } from '../../../services/worklist.service';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';

@Component({
	selector: 'bb-worklist',
	templateUrl: './bb-worklist.component.html',
	styleUrls: ['./bb-worklist.component.scss'],
})

export class BbWorklistComponent implements OnDestroy {

	worklist: any;
	worklistSubscription: any;
	sapiSubscription: any;
	hotKeyCtrlUp: Hotkey | Hotkey[];
	hotKeyCtrlDown: Hotkey | Hotkey[];

	// ensure to include pipes in our constructor
	constructor(
		public worklistService: WorklistService,
		protected hotkeysService: HotkeysService,
		protected statusIconPipe: StatusIconPipe,
		protected clipTitlePipe: ClipTitlePipe,
		protected mediatypeIconPipe: MediatypeIconPipe,
		protected router: Router,
		protected elementRef: ElementRef,
		protected routerModule: RouterModule,
		protected sapiService: SapiService) {

		// add hotkeys
		this.hotKeyCtrlUp = hotkeysService.add(new Hotkey('mod+up', this.selectPreviousItem));
		this.hotKeyCtrlDown = hotkeysService.add(new Hotkey('mod+down', this.selectNextItem));

		// subscribe to worklist changes
		this.worklistSubscription = worklistService.getTheWorklist().subscribe(worklist => {
			this.worklist = Object.assign({}, worklist);
			if (this.worklist.activeItem) {
				this.scrollToItem(this.worklist.activeItem, this.worklistService.indexOfItemById(this.worklist.activeItem.id));
			}
		});

		// subscribe to sapi service changes
		this.sapiSubscription = sapiService.getSapiChanges().subscribe(change => {
			this.determineChangeRelevance(change);
		});

		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd && event.url) {
				this.urlChanged(event.url);
			}
		});
	}

	ngOnDestroy() {
		// clean up the hotkeys and unsubscribe
		this.hotkeysService.remove(this.hotKeyCtrlUp);
		this.hotkeysService.remove(this.hotKeyCtrlDown);
	}

	urlChanged(newUrl: string) {
		if (newUrl.indexOf('/library/mediaclip/') === -1) {
			// not in mediaclip details screen
			this.worklistService.setActiveItem(null);
		} else {
			const parts = newUrl.split('/library/mediaclip/');
			const id = parts[1] ? parts[1].split('/')[0] : '';
			if (id) {
				this.worklistService.setActiveItemById(id);
			} else {
				this.worklistService.setActiveItem(null);
			}
		}
	}

	determineChangeRelevance(change: any) {
		if (!change) {
			return;
		}

		// console.warn('determine relevance of change', change, change.data, change.entityName);

		switch (change.request) {
			case 'update':
				this.worklistService.updateItemsById(change.data, change.response);
				break;
			case 'delete':
				this.worklistService.removeItemsById(change.data);
				break;
		}
	}

	scrollToItem(item: Mediaclip, i: number) {
		if (item && item.id) {
			const wrapper = this.elementRef.nativeElement.querySelector('.worklist-items');
			if (!wrapper) {
				return;
			}
			const wrapperRect = wrapper.getBoundingClientRect();
			// return ;
			const result = wrapper.getElementsByTagName('li')[i];
			if (result) {
				const rect = result.getBoundingClientRect();

				// TODO:check if wrappeRect.top is the same as $wapper.offset().top
				if (rect.top - wrapperRect.top <= 0 ||
					(rect.bottom - rect.height) > wrapperRect.height) {
					result.scrollIntoView();
				}
			}
		}
	}

	isActiveItem(item: Mediaclip) {
		// console.warn('isActiveItem item', JSON.stringify(item));
		if (item && typeof item.id !== 'undefined' && this.worklist.activeItem && typeof this.worklist.activeItem.id !== 'undefined') {
			return this.worklistService && this.worklist.activeItem && this.worklist.activeItem.id === item.id;
		} else {
			return false;
		}
	}

	isOSX() {
		return navigator.platform.toLowerCase().indexOf('mac') !== -1;
	}

	selectPreviousItem = (event: KeyboardEvent, combo: string): boolean => {
		this.worklistService.incrementItem(-1);
		return true;
	};

	selectNextItem = (event: KeyboardEvent, combo: string): boolean => {
		this.worklistService.incrementItem(1);
		return true;
	};

	tempNav(item: Mediaclip) {
		this.router.navigate(['library/mediaclip/', item.id, 'metadata']);
	}
}
